module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/people-bcc84c6f8e63af318c93706e3d8061fd.svg";